// extracted by mini-css-extract-plugin
module.exports = {"layout":"ItemsLayout_layout__VBRfQ"};